.page-overlay__container {
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 50;
}

.page-overlay {
  background: var(--color-uva-white);
  display: flex;
  flex-direction: column;

  /* dynamic view height needed to adapt for possible auto hiding of mobile address bar */
  height: 100dvh;
}

.page-overlay--full-screen {
  width: 100vw;
}

.page-overlay--with-gutters {
  max-width: 87.5rem;
  width: 100%;
}

.page-overlay__content {
  display: flex;
  flex-direction: column;
  height: 100svh;
  justify-content: space-between;
  overflow: hidden;
  overflow-y: auto;
  padding: 0 1.5rem;
  width: 100%;
}

.page-overlay__content--grey {
  background-color: var(--color-grey-200);
}

.page-overlay__content--white {
  background-color: var(--color-uva-white);
}

.page-overlay__children {
  padding-bottom: 1rem;
}

.page-overlay__title-wrapper {
  position: relative;
}

.page-overlay__title {
  font-size: var(--font-size-s);
  line-height: var(--line-height-m);
  margin: 0 1.5rem 0 0;
  padding: 1rem 1.5rem;
}

.page-overlay__buttons-bar {
  background-color: var(--color-uva-white);
  bottom: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  justify-content: flex-start;
  margin: 0 calc(-1 * 1.5rem);
  padding: 0.5rem 1rem;
  position: sticky;
  right: 0;
}

.page-overlay__buttons-bar::before {
  background: linear-gradient(to top, rgba(0 0 0 / 30%), rgba(0 0 0 / 0%));
  bottom: 100%;
  content: "";
  height: 10px;
  left: 0;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  transition: opacity 0.4s ease-out;
}

.page-overlay__buttons-bar--shadow::before {
  opacity: 1;

  /* Show the shadow when content is scrollable and not scrolled to the bottom */
}

.page-overlay__close {
  height: 1.5rem;
  position: absolute;
  right: 1rem;
  top: calc(50% - 0.125rem);
  transform: translateY(-50%);
}

@media (min-width: 28rem) and (min-height: 28rem) {
  .page-overlay--with-gutters {
    margin: 0 calc(1.5rem / 2);
  }
}
